// Hook para manejar el estado de refreshing del dashboard
// Dashboard refreshing state hook

import { useState, useCallback } from 'react';

let refreshCounter = 0;
let refreshCompleteCounter = 0;

export const useDashboardRefreshing = () => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const startRefreshing = useCallback(() => {
    refreshCounter++;
    setIsRefreshing(true);
  }, []);

  const completeRefreshing = useCallback(() => {
    refreshCompleteCounter++;
    
    // Solo marcar como completo cuando todas las APIs hayan terminado
    if (refreshCompleteCounter >= refreshCounter) {
      setIsRefreshing(false);
      refreshCounter = 0;
      refreshCompleteCounter = 0;
    }
  }, []);

  return {
    isRefreshing,
    startRefreshing,
    completeRefreshing,
  };
};
